import { createContext, useContext, useState, ReactNode } from 'react';

interface ChartInteractionContextType {
  hoveredCommunity: string | null;
  setHoveredCommunity: (community: string | null) => void;
}

const ChartInteractionContext = createContext<ChartInteractionContextType | undefined>(undefined);

export function ChartInteractionProvider({ children }: { children: ReactNode }) {
  const [hoveredCommunity, setHoveredCommunity] = useState<string | null>(null);

  return (
    <ChartInteractionContext.Provider value={{ hoveredCommunity, setHoveredCommunity }}>
      {children}
    </ChartInteractionContext.Provider>
  );
}

export function useChartInteraction() {
  const context = useContext(ChartInteractionContext);
  if (!context) {
    throw new Error('useChartInteraction must be used within ChartInteractionProvider');
  }
  return context;
}
